import React from "react";
import { image_path } from "../../environment";

// interface Image {
//   className?: string;
//   src: string;
//   alt?: string;
//   height?: number;
//   width?: number;
//   id?: string;
//   frc: string;
//   customSrc?: string;
// }

const ImageWithBasePath = (props) => {
  const altText = String(props.alt);
  const fullSrc = props.customSrc ? props.customSrc : `${image_path}${props.src}`;

  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={altText}
      width={props.width}
      id={props.id}
    />
  );
};

export default ImageWithBasePath;
